import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Rapidfreeservices() {
  return (
    <section
      className="rapid_free_services p-100 nlp_transform hire_react_platform"
      style={{ backgroundColor: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={10} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Hire ReactJS Developers <span>Easily Through Our Platform</span>
            </h3>
            <p>
              We make it easier for our clients to kickstart their project
              development by handpicking a dedicated team of ReactJS developers
              for them. Here’s the process to hire the right resource for your
              React application:
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4 mb-md-0">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>Share Your Project Requirements</h5>
                <p>
                  Provide a detailed outline of your project needs, objectives,
                  and desired outcomes.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4 mb-md-0">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5>Review and Select Developers</h5>
                <p>
                  Evaluate our pool of skilled ReactJS developers and choose the
                  experts that best match your project criteria.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4 mb-md-0">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Kickstart Your Project</h5>
                <p>
                  Evaluate our pool of skilled ReactJS developers and choose the
                  experts that best match your project criteria.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Rapidfreeservices;
